import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { setUserToLS } from '../../helpers/localstorage-helper';
import { BIG_WHALE } from '../../routes/routes';
import { changeUserInfo } from '../../slices/auth-slice';
import {
  checkSideModalAsync,
  getDashboardAsync,
  getJoinedAfterUsersAsync,
  getLastRegisteredUsersAsync,
  updatePackageRankNotificationAsync,
  getWillyCoinsAsync
} from './Dashboard.requests';
import { WillyDataResponse } from './Dashboard.types';

export const getDashboardInfo = createAsyncThunk(
  'auth/getDashboardInfo',
  async () => {
    const dashboardInfo = await getDashboardAsync();

    return {
      dashboardInfo
    };
  }
);

export const updatePackageRankNotification = createAsyncThunk(
  'auth/updatePackageRankNotification',
  async (id: number) => {
    await updatePackageRankNotificationAsync(id);
    return id;
  }
);

export const checkSideModal = createAsyncThunk(
  'auth/checkSideModal',
  async (
    history: {
      push(url: string): void;
    },
    { getState, dispatch }
  ) => {
    await checkSideModalAsync();

    const state = getState() as RootState;

    const user = { ...state.auth.userInfo, isSideModalChecked: true };

    dispatch(changeUserInfo(user));

    setUserToLS(user);
  }
);

export const updateWillyCoins = createAsyncThunk(
  'auth/updateWillyCoins',
  ({ totalCoins, coinsPerChange }: WillyDataResponse) => {
    let willyCoins = {
      totalCoins: (totalCoins += coinsPerChange)
    };

    return willyCoins;
  }
);
